import React from "react";
import { comboRegex } from "../../helpers/methods";
import { useController } from "react-hook-form";
import { useRecordContext } from "react-admin";
import TextField from "@mui/material/TextField";

export const extractProductDescription = (fullDescription) => {
  const spacelessDescription = fullDescription.replace(/\s/g, " ").trim();
  const matches = comboRegex.exec(spacelessDescription);
  if (matches) {
    const [, productDescription] = matches;
    return productDescription.trim();
  } else {
    return fullDescription.trim();
  }
};
const EditItemDescription = () => {
  const record = useRecordContext();
  const productDescription = extractProductDescription(record.description);
  const { field } = useController({
    name: "item",
    defaultValue: productDescription,
    rules: { required: true },
  });

  return (
    <TextField
      {...field}
      label="Item Description (no need quantity)"
      fullWidth
    />
  );
};

export default EditItemDescription;
